import axios from "axios";
const jsonConfig = require("../../Config.json");

const updateTestTakenResponse = async (invitedId, payload) => {
  let allResponse = {};
  try {
    const getallresponse = await axios.put(
      jsonConfig.apiUrl + "UpdateTestTaken/" + invitedId,
      payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = getallresponse;
    return Promise.resolve(allResponse);
  }
  catch (error) {
    console.log("Error updateing test result", error);
    return Promise.reject(error);
  }
}

export default updateTestTakenResponse;